document.querySelectorAll('.hero-slider-section').forEach((hss) => {
    const slideWrapper = hss.querySelector('.the-slides');
    const heroSlides = hss.getElementsByClassName('hero-slide');
    const slideLength = heroSlides.length - 1;
    const next = hss.querySelector('.hero-slider .next-slide i');
    const previous = hss.querySelector('.hero-slider .previous-slide i');
    const icons = hss.querySelectorAll('.icon-section');
    const iconsLength = icons.length;
    let active = 1;
    let translate = 0;
    let edgeSlide;
    const slideTime = 9000;
    let slideTimer;

    function changeSlide(direction = 'forward') {
        clearInterval(slideTimer);
        if (direction === 'forward') {
            active = active === iconsLength ? 1 : active + 1;
            translate === slideLength * -100 ? newEdgeSlide(0, 100) : newSlide(-100);
        } else {
            active = active === 1 ? iconsLength : active - 1;
            translate === 0 ? newEdgeSlide(slideLength, -100) : newSlide(100);
        }
        newActiveIcon();
        slideTimer = setInterval(() => {
            changeSlide();
        }, slideTime);
    }

    if (icons) {
        icons.forEach((i) => {
            i.addEventListener('mouseover', () => {
                clearInterval(slideTimer);
                active = Number(i.dataset.icon);
                newActiveIcon();
                newActiveSlide();
                translate = (active - 1) * -100;
                translateSlides();
            });
            i.addEventListener('mouseleave', function () {
                slideTimer = setInterval(() => {
                    changeSlide();
                }, slideTime);
            });
        });
    }

    function newSlide(t) {
        translate += t;
        translateSlides();
        newActiveSlide();
        pauseArrowFunctions();
    }

    function newEdgeSlide(es, t) {
        newActiveSlide(510);
        pauseArrowFunctions(400);
        // 1) Moves last slide to the end and translates slides to be in position of 2nd slide simultaneously
        edgeSlide = heroSlides[es];
        es === 0 ? slideWrapper.append(edgeSlide) : slideWrapper.prepend(edgeSlide);
        translate += t;
        translateEdgeSlides();
        // 2) Moves slides over as normal
        translate -= t;
        setTimeout(() => {
            translateSlides();
        }, 100);
        // 3) Moves last slide back to last position and translates slides to position of last slide simultaneously
        setTimeout(() => {
            es === 0 ? slideWrapper.prepend(edgeSlide) : slideWrapper.append(edgeSlide);
            translate = es * -100;
            translateEdgeSlides();
        }, 500);
    }

    function translateSlides() {
        hss.querySelectorAll('.hero-slide').forEach((slide) => {
            slide.style.transition = 'transform .4s ease';
            slide.style.transform = 'translateX(' + translate + '%)';
        });
    }

    function translateEdgeSlides() {
        hss.querySelectorAll('.hero-slide').forEach((slide) => {
            slide.style.transition = 'transform 0s ease';
            slide.style.transform = 'translateX(' + translate + '%)';
        });
    }

    function newActiveIcon() {
        setTimeout(() => {
            hss.querySelector('.active-icon').classList.remove('active-icon');
            hss.querySelector('.icon-' + active).classList.add('active-icon');
        }, 200);
    }

    function newActiveSlide(transition = 350) {
        setTimeout(() => {
            hss.querySelector('.active-slide').classList.remove('active-slide');
            hss.querySelector('.slide-' + active).classList.add('active-slide');
        }, transition);
    }

    function pauseArrowFunctions(timeOut = 400) {
        next.style.pointerEvents = 'none';
        previous.style.pointerEvents = 'none';
        setTimeout(() => {
            next.style.pointerEvents = 'auto';
            previous.style.pointerEvents = 'auto';
        }, timeOut);
    }

    if (next) {
        next.addEventListener('click', () => {
            changeSlide();
        });
    }
    if (previous) {
        previous.addEventListener('click', () => {
            changeSlide('backwards');
        });
    }

    if (slideLength > 0) {
        slideTimer = setInterval(() => {
            changeSlide();
        }, slideTime);
    }

    setTimeout(() => {
        hss.querySelector('.slide-1').classList.add('active-slide');
    }, 100);
});



// WEBPACK FOOTER //
// ./app/js/modules/hero-slider.js